import React from "react";
import s from "./style.module.scss";
import { useAppDispatch } from "shared/redux/hooks";
import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";
import Button from "../Button";

interface SuccessProps {
  title: string;
  text: string;
}

const Success: React.FC<SuccessProps> = ({ text, title }) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setOpen(false));
    dispatch(setContent(null));
  };

  return (
    <div className={s.success}>
      <h6 className={s.title}>{title}</h6>
      <p className={s.text}>{text}</p>

      <Button onClick={handleClose} className={s.button}>
        Закрыть
      </Button>
    </div>
  );
};

export default Success;
